interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    pages.push(i);
  }

  const btn =
    "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-3 text-sm transition-colors";

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${btn} border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btn} ${
            p === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`${btn} border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </div>
  );
}